module.exports = {
      id: "ic-stochastic-momentum-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-ad374a.smartcharts.svg#ic-stochastic-momentum-usage",
      toString: function () {
        return this.url;
      }
    }